import { NavLink, useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';
import type { Role } from '../../shared/types';

const NAV: Record<Role, { to: string; label: string }[]> = {
  plumber: [
    { to: '/referrals', label: 'Referrals' },
    { to: '/referrals/new', label: 'Add Customer' },
  ],
  dispatch: [
    { to: '/dispatch', label: 'Queue' },
    { to: '/dispatch/users', label: 'Users' },
    { to: '/dispatch/teams', label: 'Teams' },
  ],
  tech: [{ to: '/jobs', label: 'My Jobs' }],
  recon: [{ to: '/jobs', label: 'My Jobs' }],
};

export function AppShell({ title, children }: { title: string; children: ReactNode }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const links = user ? NAV[user.role] : [];

  return (
    <>
      <header
        style={{
          background: 'var(--navy)',
          color: '#fff',
          padding: '0.75rem 1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.5rem',
        }}
      >
        <strong
          style={{
            fontSize: '1.05rem',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </strong>
        <button
          type="button"
          onClick={async () => {
            await signOut();
            navigate('/login');
          }}
          style={{
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.4)',
            color: '#fff',
            borderRadius: 'var(--radius-sm)',
            minHeight: 'var(--tap)',
            padding: '0 0.75rem',
            fontSize: '0.9rem',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          Sign out
        </button>
      </header>

      <main className="page">{children}</main>

      {links.length > 0 && (
        <nav
          style={{
            position: 'fixed',
            insetInline: 0,
            bottom: 0,
            background: 'var(--surface)',
            borderTop: '1px solid var(--line)',
            display: 'flex',
            paddingBottom: 'env(safe-area-inset-bottom)',
          }}
        >
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end
              style={({ isActive }) => ({
                flex: 1,
                textAlign: 'center',
                padding: '0.7rem 0.25rem',
                minHeight: 'var(--tap)',
                fontSize: '0.85rem',
                fontWeight: 600,
                textDecoration: 'none',
                color: isActive ? 'var(--azure-700)' : 'var(--muted)',
                borderTop: `3px solid ${isActive ? 'var(--azure)' : 'transparent'}`,
              })}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      )}
    </>
  );
}
